import { render, staticRenderFns } from "./YearlyFinancialTable.vue?vue&type=template&id=38e92d40&"
import script from "./YearlyFinancialTable.vue?vue&type=script&lang=ts&"
export * from "./YearlyFinancialTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38e92d40')) {
      api.createRecord('38e92d40', component.options)
    } else {
      api.reload('38e92d40', component.options)
    }
    module.hot.accept("./YearlyFinancialTable.vue?vue&type=template&id=38e92d40&", function () {
      api.rerender('38e92d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/molecules/organization/profile/key-performance-indicators/YearlyFinancialTable.vue"
export default component.exports